import CreatableSelect from 'react-select/creatable'

const SelectCreatable = ({
    name,
    value,
    label = '',
    options = [],
    required = false,
    onChange = () => {},
    showError,
    error,
    className,
    outerDivStyles = 'm-2 p-1',
    borderStyles = 'inherit',
    placeholderStyles = {},
    selectClassName,
    labelClassName,
    errorClassName,
    size,
    width,
    isClearable,
    onInputChange = () => {},
    onKeyDown = () => {},
    disabled,
    noOptions = 'No Options Found',
    placeholder,
    onErrorUpdate = () => {},
    isMulti = false,
    isSearchable = true,
    createNewOption = () => {},
    // formatCreateLabel = () => {},
    isAllowCreation = false,
    ...props
}) => {
    const customStyles = {
        select: (baseStyles) => ({
            ...baseStyles,
            borderColor: disabled ? '#ededed' : 'white',
        }),
        control: (baseStyles, state) => ({
            ...baseStyles,
            backgroundColor: disabled ? '#eeeeee !important' : 'white',
            borderColor: disabled ? '#eeeeee' : 'white',
            border: state.isFocused
                ? borderStyles
                : error
                ? '1px solid #dc2804'
                : 'inherit',
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
            padding: '5px 0',
            fontSize: placeholderStyles.fontSize || '13px',
            '&:hover': {
                borderColor: error ? '#dc2804' : 'inherit',
            },
        }),
        placeholder: (providedStyles) => ({
            ...providedStyles,
            fontSize: placeholderStyles.fontSize || '14px',
            color: disabled ? '#999' : placeholderStyles.color || '#AFAFAF',
        }),
        indicatorSeparator: () => ({ display: 'none' }),
        option: (providedStyles) => ({
            ...providedStyles,
            padding: '10px !important',
            fontSize: '12px',
        }),
        menu: (providedStyles) => ({
            ...providedStyles,
            width: '98%',
        }),
        singleValue: (providedStyles) => ({
            ...providedStyles,
            fontWeight: placeholderStyles.fontWeight || 500,
        }),
    }

    const handleOnChange = (value) => {
        onChange({ name, value })
    }
    const formatCreateLabel = (inputValue) => `${inputValue}`

    return (
        <div className={className}>
            {!!label && <label className={labelClassName}>{label}</label>}
            <CreatableSelect
                name={name}
                required={required}
                className={outerDivStyles}
                classNamePrefix={'reactSelect'}
                onChange={handleOnChange}
                isSearchable={isSearchable}
                isDisabled={disabled}
                options={options}
                value={value}
                placeholder={placeholder || 'Select'}
                styles={customStyles}
                formatCreateLabel={(val) => {
                    if (isAllowCreation) return formatCreateLabel(val)
                }}
                onInputChange={onInputChange}
                onKeyDown={onKeyDown}
                noOptionsMessage={() => noOptions}
                isMulti={isMulti}
                onError={(error) => {
                    onErrorUpdate(name, error)
                }}
                allowCreateWhileLoading
                // defaultMenuIsOpen
                {...props}
            />
            {showError && error ? (
                <p className="font-size-xs text-error-red">{error}</p>
            ) : null}
        </div>
    )
}

export default SelectCreatable
